import { hasCapability, type User } from "../base";

export const projectChecklistSchema = {
  read: (user: User) => hasCapability(user, "projectChecklistSchema.read"),
  create: (user: User) => hasCapability(user, "projectChecklistSchema.create"),
};
